import { NgbModal, NgbPopover, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FileUploadControl, FileUploadModule } from '@iplab/ngx-file-upload';
import { CmsService, ContentSlotData, GlobalMessageService, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { KnBrDocViewerComponent } from 'src/app/common/kn-br-doc-viewer/kn-br-doc-viewer.component';

import { KnBrCommonService } from '../../../services/kn-br-common.service';
import { KnBrQuotesService } from '../../../store/kn-br-quotes/kn-br-quotes.service';

@Component({
    selector: 'kn-br-quote-attachment-link',
    templateUrl: './kn-br-quote-attachment-link.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [FileUploadModule, NgbTooltip, TranslatePipe]
})
export class KnBrQuoteAttachmentLinkComponent implements OnInit {
  @ViewChild('tooltip') tooltip: NgbTooltip;
  quote: any;
  public fileUploadControl = new FileUploadControl().setListVisibility(false).setValidators([Validators.required]);
  components: ContentSlotData;
  documentTypes =
    '.csv,.DOC,.DOCX, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.pdf';
  modalRef;
  constructor(
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService,
    protected cdr: ChangeDetectorRef,
    protected modalService: NgbModal,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.knBrQuoteService.get$.subscribe((response) => {
      this.quote = response as any;
      this.cdr.markForCheck();
      if (this.quote && this.quote.quoteAttachment && !this.isDisabled()) {
        this.openToolTip();
      }
    });
    this.knBrQuoteService.loadAttachmentMsg().subscribe((res) => {
      if (res) {
        this.openToolTip();
      } else {
        this.closeToolTip();
      }
    });
    this.fileUploadControl.valueChanges.subscribe((value) => {
      this.closeToolTip();
      if (value && value.length) {
        this.onSubmit();
      }
    });
  }

  openToolTip(): void {
    if (this.tooltip) {
      this.tooltip.open();
    }
  }

  closeToolTip(): void {
    if (this.tooltip) {
      this.tooltip.close();
    }
  }

  onSubmit() {
    this.closeToolTip();
    if (this.quote && !this.quote?.quoteAttachment) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.knBrCommonService.uploadQuoteAttachment(formData);
    } else {
      this.globalMessageService.add({ key: 'knBrMessages.removeFileFirst' }, GlobalMessageType.MSG_TYPE_WARNING);
    }
    this.fileUploadControl.clear();
  }
  removeFile() {
    this.knBrCommonService.deleteAttachment(this.quote.quoteAttachment);
  }

  openModal() {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrDocViewerComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.url = this.quote.docURL;
    modalInstance.attachmentName = this.quote.quoteAttachment;
  }

  isDisabled() {
    this.cmsService
      .getContentSlot('KnBrQuoteHeaderSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();

    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrQuoteHeaderComponentReadOnly') ||
      !this.quote.editable
    ) {
      return true;
    }
    return false;
  }
}
